<div class=" order_sum_wrapper wrapper_mng_emp">
    <fieldset class="scheduler-border">
        <legend class="scheduler-border">Search Criteria</legend>
        <form name="form" #tagRpt="ngForm" (ngSubmit)="searchTagRpt(1)" autocomplete="off">

            <div class="search-criteria">
                <div class="row">
                    <div class="col-sm-3 order_sum_col order_sum_colSp">
                        <div class="form-group has-feedback tag-reporting-fa">
                            <label for="dateFrom" class="control-label">Date From:</label>
                            <input class="form-control" id="dateFrom" name="dateFrom" [(ngModel)]="DateFrom" [maxDate]="DateTo" ngbDatepicker #dateFrom="ngbDatepicker" style="cursor: pointer;" (click)="dateFrom.toggle()" readonly required>
                            <i (click)="dateFrom.toggle()" class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="col-sm-3 order_sum_col order_sum_colSp">
                        <div class="form-group has-feedback tag-reporting-fa">
                            <label for="DateTo" class="control-label">Date To:</label>
                            <input class="form-control" id="DateTo" name="DateTo" [(ngModel)]="DateTo" ngbDatepicker [maxDate]="maxDate" [minDate]="DateFrom" #dateTo="ngbDatepicker" style="cursor: pointer;" (click)="dateTo.toggle()" readonly required>
                            <i (click)="dateTo.toggle()" class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="col-sm-2 order_sum_col order_sum_colSp">
                        <div class="form-group has-feedback">
                            <label for="lotNumber" class="control-label">Lot Number</label>
                            <input type="text" id="lotNumber" name="lotNumber" placeholder="Enter lot number" [(ngModel)]="tagReportSearchCriteria.LotNumber" #lotNumber="ngModel" class="form-control" minlength="1" maxlength="5" appOnlynumber [ngClass]="{ 'is-invalid': lotNumber.invalid && (lotNumber.dirty || lotNumber.touched)}"
                                required />

                            <div *ngIf="lotNumber.invalid && (lotNumber.dirty || lotNumber.touched)" class="invalid-feedback">
                                <div *ngIf="lotNumber.errors.required">Lot Number is required</div>
                                <div *ngIf="lotNumber.errors.minlength || lotNumber.errors.maxlength">Min 1 to 5 numbers are allowed</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group orders_sum_top tag_report">
                            <div class="pull-right">
                                <button type="submit" [disabled]="!tagRpt.valid" class="btn btn-primary">Search</button>
                                <button (click)="cancelSearch()" class="btn btn-default">Clear</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </fieldset>

    <fieldset class="scheduler-border marign_10">
        <legend class="scheduler-border">Tag Report</legend>
        <div class="panel_table">
            <div class="panel panel-default">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>
                                <th>Class Code</th>
                                <th>Lot #</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Invoice #</th>
                                <th>Account #</th>
                                <th>Customer Name</th>
                                <th>Drop Date</th>
                                <th>Due Date</th>
                                <th>Pickup Date</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let mod of tagReport?.LotTaggingRpt">
                                <td> {{mod.classCode}}</td>
                                <td> {{mod.LotNumber}}</td>
                                <td> {{mod.TagStartNo}}</td>
                                <td> {{mod.TagStopNo}}</td>
                                <td style="text-align:right"> {{mod.InvoiceNo}}</td>
                                <td style="text-align:right"> {{mod.AccountNo}}</td>
                                <td> {{mod.FirstName}} {{ mod.LastName}}</td>
                                <td> {{mod.DropDate | date:'MM/dd/yyyy'}}</td>
                                <td> {{mod.DueDate | date:'MM/dd/yyyy'}}</td>
                                <td> {{mod.pickUpDate | date:'MM/dd/yyyy'}}</td>
                                <td> {{mod.RackNumber}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class=" paraNoRec">
                        <p *ngIf="paraNoRec == true">No Record Found</p>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>

</div>